import clsx from "clsx"
import classes from "./InputWithButtons.module.scss"
import { useClickAway } from "@educaplay/core/hooks"
import { forwardRef } from "react"

const InputWithButtons = forwardRef(function InputWithButtons(props, ref) {
    const { type =  "text", className, show, children, ...inputProps } = props
      
    const containerRef = useClickAway (()=>{
        show(false);
    })

    return (
        <div className={clsx(classes.fullwidth, className)}>
            <div className={classes.inputWrapper} ref={containerRef}>
                <input className={classes.input} type={type} ref={ref} {...inputProps} />
                <div className={classes.actions}>
                    {children}
                </div>
            </div>
        </div>
    )
})

export default InputWithButtons